import { PopularSearchTextSection } from './PopularSearchTextSection'
import { withPopularTextSearchSection } from './withPopularSearchTextSection'

const ConnectedStory = withPopularTextSearchSection(PopularSearchTextSection)

export { ConnectedStory as PopularSearchTextSection }
